module.exports = __webpack_public_path__ + "static/media/Week5.9ccdc47a.pdf";